import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { SocieteAdministratifDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteAdministratifDto";
import { CommuneDto } from "../../../dto/GenApi.iNotPaie.Dto/CommuneDto";
import moment from "moment";
import { NeoresEffectifDto } from "../../../dto/GenApi.iNotPaie.Dto/NeoresEffectifDto";
import { NeoresCodeEffectif } from "../../../dto/GenApi.iNotPaie.Dto/NeoresCodeEffectif";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ModificationMdpUrssafDto } from "../../../dto/GenApi.iNotPaie.Dto/ModificationMdpUrssafDto";
import { SocieteReglementsDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteReglementsDto";
import { CodeUrssafDto } from "../../../dto/GenApi.iNotPaie.Dto/CodeUrssafDto";
import { CodeSstDto } from "../../../dto/GenApi.iNotPaie.Dto/CodeSstDto";

@Component
export default class AdministratifSocieteComponent extends Vue {
	public isModified = false;
	public SocieteAdministratif: SocieteAdministratifDto = { Id: 0, ReconductionConges: false, ListeAnneesEffectifs: [], AnneeEffectif: 0, ListeEffectifs: [] };
	public dateChangementSiret?: string;
	public dataReady = true;
	public listeCommune: CommuneDto[] = [];
	public codePostal = "";
	public ville = "";
	public estModeDemarrage = false;
	public estSiretPrecentVisible = true;
	public listeAnneesEffectifs: number[] = [];
	public anneeSelectionnee = 0;
	public listeEffectifs: NeoresEffectifDto[] = [];
	public isMdpUrssafModified = false;
	public listeMoisSuspension: string[] = ParametresInstance.listeMois;
	public indexMoisSuspension?: number;
	public societeReglements: SocieteReglementsDto = { Id: 0, ReglementType: [] };
	public listeCodesUrssaf: CodeUrssafDto[] = [];
    public codeUrssafOrganisme = "";
    public listeCodesSst: CodeSstDto[] = [];
    public sstLoading: boolean = false;

	public Init(): void {
    	this.dataReady = false;
    	this.isMdpUrssafModified = false;

    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
    		ServicesFactoryInstance.SocieteService.getSocieteAdministratif(ParametresInstance.societeCourante.Code, (data) => {
    			this.SocieteAdministratif = data;
    			this.indexMoisSuspension = this.SocieteAdministratif.MoisSuspension ? this.SocieteAdministratif.MoisSuspension - 1 : undefined;
    			this.codePostal = data.CodePostal != undefined ? data.CodePostal : "";
    			this.ville = data.Ville != undefined ? data.Ville : "";

    			this.dateChangementSiret = data.DateChangementSiret != undefined ? moment.utc(data.DateChangementSiret).format("YYYY-MM-DD") : "";

    			this.listeAnneesEffectifs = data.ListeAnneesEffectifs;
    			if (this.listeAnneesEffectifs.length > 0) {
    				this.anneeSelectionnee = data.AnneeEffectif;
    			}
    			this.listeEffectifs = data.ListeEffectifs;

    			this.isModified = false;
    			this.$emit("isModified", false);

    			this.dataReady = true;

    			this.estModeDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
    			if (this.estModeDemarrage || (data != undefined && data.SiretPrecedent != undefined && (data.SiretPrecedent as any) != "")) {
    				this.estSiretPrecentVisible = true;
    			} else {
    				this.estSiretPrecentVisible = false;
    			}

    			ServicesFactoryInstance.ParametresService.getListeCodesUrssaf(data => {
    				this.listeCodesUrssaf = data;

    				// On filtre la liste des code URSSAF en fonction du siret déjà inscrit, sinon on met toute la liste
    				this.setCodeUrssafOrganisme();
    			});

    			this.$forceUpdate();
    		});

    		ServicesFactoryInstance.SocieteService.getSocieteReglements(ParametresInstance.societeCourante.Code, (data) => {
    			this.societeReglements = data;
    		});
    	}
    	this.listeCommune = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(this.ville.toLowerCase()) >= 0).slice(0, 24);
	}

	@Watch("codePostal")
	public onCodePostalCherchePropertyChanged(): void {
    	this.listeCommune = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(this.codePostal.toLowerCase()) >= 0).slice(0, 24);
	}

	@Watch("ville")
	public onCommuneCherchePropertyChanged(): void {
    	this.listeCommune = ParametresInstance.allCommune.filter(c => c.LibelleCodePostale != undefined && c.LibelleCodePostale.toLowerCase().indexOf(this.ville.toLowerCase()) >= 0).slice(0, 24);
	}

	public modifyCommune(libelleCodePostal: string): void {
    	let commune;
    	for (let i = 0; i < this.listeCommune.length; i++) {
    		if (this.listeCommune[i].LibelleCodePostale == libelleCodePostal ||
                this.listeCommune[i].CodePostal == libelleCodePostal ||
                this.listeCommune[i].Libelle == libelleCodePostal) {
    			commune = this.listeCommune[i];
    			break;
    		}
    	}

    	if (commune != undefined) {
    		this.codePostal = commune.CodePostal;
    		this.ville = commune.Libelle;
    	}

    	this.champModified();
	}

	public champMdpUrssafModified(): void {
    	this.isMdpUrssafModified = true;
    	this.champModified();
    }

    public champMoisRazModified(): void {
        NotificationServiceInstance.SendWarning("Vous avez modifié le mois de remise à zéro des congés payés, pensez à modifier les bases de congés payés dans les fiches de vos salariés (rubriques 058 et 058A)");
        this.champModified();
    }

	public champModified(champModifie?: string): void {
    	if (champModifie != null && champModifie === "siretUrssaf") {
			this.setCodeUrssafOrganisme();
    	}

    	this.isModified = true;
    	this.$emit("isModified", true);
	}

	public annuler(): void {
    	this.Init();
	}

	public update(): void {
    	this.SocieteAdministratif.Ville = this.ville;
    	this.SocieteAdministratif.CodePostal = this.codePostal;

    	this.SocieteAdministratif.DateChangementSiret = this.dateChangementSiret != "" ? moment.utc(this.dateChangementSiret).toDate() : undefined;

    	if (this.SocieteAdministratif.Libelle && this.SocieteAdministratif.Libelle.length > 60) {
    		NotificationServiceInstance.SendFailed("Le nom de la société ne doit pas dépasser 60 caractères.");

    		return;
		}

    	if (this.SocieteAdministratif.Ville && this.SocieteAdministratif.CodePostal && ParametresInstance.allCommune.filter(c => c.Libelle == this.SocieteAdministratif.Ville && c.CodePostal == this.SocieteAdministratif.CodePostal).length == 0) {
    		NotificationServiceInstance.SendFailed("Aucune ville n'a été retrouvée pour le code postal et le libellé de commune renseignés.<br>Veuillez sélectionner un résultat dans la liste des propositions lors de la saisie du code postal ou de la commune.");

    		return;
    	}

    	if (this.SocieteAdministratif.SiretUrssafDpae || this.SocieteAdministratif.NomUrssafDpae || this.SocieteAdministratif.PrenomUrssafDpae) {
    		if (!(this.SocieteAdministratif.SiretUrssafDpae && this.SocieteAdministratif.NomUrssafDpae && this.SocieteAdministratif.PrenomUrssafDpae)) {
    			NotificationServiceInstance.SendFailed("Veuillez remplir toutes les données d'identification URSSAF.");

    			return;
    		}
		}

		const urssaf = this.getUrssafSelectionne();
		if (urssaf.length === 0 || this.codeUrssafOrganisme === "") {
			NotificationServiceInstance.SendFailed("Le siret URSSAF est invalide. Il doit être lié à un code URSSAF existant.");

			return;
		}

    	this.SocieteAdministratif.MoisSuspension = this.indexMoisSuspension ? this.indexMoisSuspension + 1 : undefined;

    	ServicesFactoryInstance.SocieteService.updateSocieteAdministratif(this.SocieteAdministratif, () => {
    		if (this.isMdpUrssafModified) {
    			// Mise a jour du mot de passe DPAE si il a été modifié
    			this.updateMdpUrssaf();
    		} else {
    			NotificationServiceInstance.SendSuccess("La société a bien été modifiée.");

    			// Récupérération des infos la société modifiée
    			this.Init();
    		}
    	});
	}

	public getCodeEffectif(code: NeoresCodeEffectif): string {
    	return NeoresCodeEffectif[code];
	}

	public anneeEffectifsModified() {
    	if (this.anneeSelectionnee == undefined) {
    		this.listeEffectifs = [];

    		return;
    	}

    	ServicesFactoryInstance.DsnService.getListeEffectifs(this.anneeSelectionnee, (data) => {
    		this.listeEffectifs = data;
    	}, () => { });
	}

	private updateMdpUrssaf(): void {
    	const infosModif: ModificationMdpUrssafDto = {
    		CodeSociete: this.SocieteAdministratif.Code,
    		NouveauMdp: this.SocieteAdministratif.MdpUrssafDpae ? this.SocieteAdministratif.MdpUrssafDpae : ""
    	};

    	ServicesFactoryInstance.DpaeService.updateMdpDpae(infosModif, () => {
    		NotificationServiceInstance.SendSuccess("La société a bien été modifiée.");

    		// Récupérération des infos la société modifiée
    		this.Init();
    	}, () => {
    		NotificationServiceInstance.SendFailed("La société a bien été modifiée, mais une erreur est survenue lors de l'enregistrement du mot de passe URSSAF.");

    		this.Init();
    	});
	}

	private setCodeUrssafOrganisme(): void {
        this.codeUrssafOrganisme = "";

		const urssaf = this.getUrssafSelectionne()[0];

        if (urssaf !== undefined) {
            this.codeUrssafOrganisme = urssaf.Code + "/" + urssaf.Denomination;

            this.sstLoading = true;
            ServicesFactoryInstance.ParametresService.getListeCodesSst(urssaf.Code!, data => {
                this.listeCodesSst = data;

                // Si le code SST n'est pas dans la liste et qu'il n'est pas déjà vide, on le supprime
                if (this.listeCodesSst.findIndex(l => l.CodeSST == this.SocieteAdministratif.CodeServiceSST) == -1 && this.SocieteAdministratif.CodeServiceSST) {
                    this.SocieteAdministratif.CodeServiceSST = undefined;
                }

                this.listeCodesSst.sort((a, b) => {
                    return a.CodeSST!.localeCompare(b.CodeSST!);
                });

                this.sstLoading = false;
            });
        } else {
            //Si le siret n'est pas dans la liste, on vide le service SST s'il n'est pas déjà vide
            if (this.SocieteAdministratif.CodeServiceSST) {
                this.SocieteAdministratif.CodeServiceSST = undefined;
            }

            this.sstLoading = false;
        }
    }

    public getServiceSstTitle(): string {
        let title: string = "";

        if (this.SocieteAdministratif.CodeServiceSST && this.SocieteAdministratif.CodeServiceSST !== "") {
            title = this.SocieteAdministratif.CodeServiceSST + "/" + this.listeCodesSst.find(c => c.CodeSST == this.SocieteAdministratif.CodeServiceSST)?.Libelle;
        }

        return title;
    }

	private getUrssafSelectionne(): CodeUrssafDto[] {
		return this.listeCodesUrssaf.filter(c => c.Siret == this.SocieteAdministratif.SiretUrssaf);
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSociete/administratif/administratifSociete.ts